// extracted by mini-css-extract-plugin
export default {"container":"AvatarNamed_container__sCluZ","name":"AvatarNamed_name__EExJe"};